/**
 * https://www.pdftron.com/api/web/Core.DocumentViewer.html#getToolMode__anchor
 */
export default () => window.documentViewer.getToolMode();